module.exports = __webpack_public_path__ + "img/grillef-chicken.284d6673.png";